export const minutes = 60;
export const hours = minutes*60;
export const days = hours*24
export const weeks = days*7;
export const epoch = 12;
export const waitingTime = minutes*10;
export const claimingPeriod = days*90;
export const pickerPct = 5;
export const networkDefault = 137;
export const networkList = {
  1337: {
    "symbol": 'MATIC',
    "amountPerBet": 1,
    "explorerName" : "Polygonscan",
    "explorerUrl": "https://polygonscan.com/tx/",
    "explorerAddressUrl": "https://polygonscan.io/address/",
    "lotteryStarted": false,
  },
  137: {
    "symbol": 'MATIC',
    "amountPerBet": 1,
    "explorerName": "Polygonscan",
    "explorerUrl": "https://polygonscan.com/tx/",
    "explorerAddressUrl": "https://polygonscan.io/address/",
    "lotteryStarted": false,
  },
  80001: {
    "symbol": 'MATIC',
    "amountPerBet": 1,
    "explorerName": "Polygonscan",
    "explorerUrl": "https://mumbai.polygonscan.com/tx/",
    "explorerAddressUrl": "https://mumbai.polygonscan.io/address/",
    "lotteryStarted": true,
  },
  5: {
    "symbol": 'ETH',
    "amountPerBet": 0.001,
    "explorerName": "Etherscan",
    "explorerUrl": "https://goerli.etherscan.io/tx/",
    "explorerAddressUrl": "https://goerli.etherscan.io/address/",
    "lotteryStarted": true,
  },
  11155111: {
    "symbol": 'ETH',
    "amountPerBet": 0.001,
    "explorerName": "Etherscan",
    "explorerUrl": "https://sepolia.etherscan.io/tx/",
    "explorerAddressUrl": "https://sepolia.etherscan.io/address/",
    "lotteryStarted": true,
  }
};


export const fromWei = (_amount) => {
  return _amount/1e18;
}

export const getTimestamp = () => {
  return parseInt(Date.now()/1000);
}

export const round = (num, digits=0) => {
  const res = Math.round(num*10**digits)/10**digits
  // return res.toFixed(digits);
  return res;
}